export const SET_CONTACTS = "SET_CONTACTS";
